import { authorizationUrl, clientAppId, scope, redirectUrl } from './constants';

export default function login() {
  const url = `${authorizationUrl}?prompt=login&scope=${scope}&response_type=code&client_id=${clientAppId}&redirect_uri=${redirectUrl}`;

  window.location.href = url;
  return;
}
